export default __webpack_public_path__ + "static/media/pdf.fd7fa6cd.svg";